<template>
  <div id="app_settings">
    <vue-element-loading :active="appLoading" :is-full-screen="true" />

    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#00a972" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout v-if="!passwordsts" wrap justify-center>
      <v-flex pa-4>
        <v-card id="app_height">
          <v-layout pt-8 wrap justify-center>
            <v-flex xs12 sm2 md1 text-center>
              <v-btn x-large icon router-link to="/Settings">
                <v-img src="../../assets/icons/back.png" aspect-ratio="1" contain height="400">
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-btn>
            </v-flex>
            <v-flex xs12 sm8 md10 text-center>
              <span style="font-size:28px;font-weight:500;color:#464646">Password</span>
            </v-flex>
            <v-flex xs12 sm2 md1></v-flex>
          </v-layout>
          <v-layout wrap justify-center px-2>
            <v-flex xs12 sm12 md8>
              <v-layout pb-4 wrap justify-center>
                <v-flex xs12 sm12 md12 pt-12 text-center>
                  <span style="font-size:14px;font-weight:400;">
                    To change your password, you’ll need to verify the current one first.
                    Then create a password you’re not using elsewhere, and be sure to change
                    it regularly as well as anytime you suspect it’s been compromised.
                  </span>
                </v-flex>
              </v-layout>

              <v-layout v-if="!enableChange" py-4 pb-4 wrap justify-center>
                <v-flex xs6 sm4 md4 text-center>
                  <span style="font-size:14px;font-weight:400;">Current Password</span>
                </v-flex>
                <v-flex xs6 sm4 md4 justify-start>
                  <v-text-field
                    class="curpswd"
                    ref="oldpassword"
                    placeholder="●●●●●●●●"
                    v-model="oldpassword"
                    :error-messages="msg_oldPassword"
                    type="password"
                    color="#26af82"
                    dense
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 md4 text-right>
                  <v-btn
                    router-link
                    width="220"
                    class="text-capitalize"
                    light
                    small
                    :ripple="false"
                    color="#FCFCFC"
                    @click="checkPassword"
                  >Change Password</v-btn>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout v-if="enableChange" pt-4 wrap justify-center>
                <v-flex text-center>
                  <v-layout pt-4>
                    <v-flex xs12 sm12 md12 text-center>
                      <span style="font-size:18px;font-weight:500;color:#232323">Password Reset</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pt-4 wrap justify-center>
                    <v-flex xs10 sm12 md4 text-center>
                      <v-text-field
                        ref="password"
                        color="#26af82"
                        v-model="password"
                        :rules="[rules.required,rules.min,rules.password]"
                        :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="passwordShow ? 'text' : 'password'"
                        @click:append="passwordShow = !passwordShow"
                        :error-messages="msg_password0"
                        label="New Password"
                        required
                      ></v-text-field>
                      <v-text-field
                        ref="confPassword"
                        v-model="confPassword"
                        :rules="[rules.required,rules.min,rules.password]"
                        :append-icon="passwordShow2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="passwordShow2 ? 'text' : 'password'"
                        @click:append="passwordShow2 = !passwordShow2"
                        :error-messages="msg_password"
                        label="Repeat new password"
                        color="#26af82"
                        required
                      ></v-text-field>
                      <v-btn
                        width="220"
                        class="text-capitalize"
                        dark
                        small
                        :ripple="false"
                        color="#26af82"
                        @click="submit"
                      >Change Password</v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout py-8 pb-12>
                    <v-flex>
                      <v-btn
                        class="text-capitalize"
                        router-link
                        to="/Settings"
                        text
                        dark
                        small
                        :ripple="false"
                        color="#2475E2"
                      >Cancel</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <SuccessPage v-if="passwordsts" />
  </div>
</template>
<script>
import axios from "axios";

import SuccessPage from "./Success";
export default {
  components: {
    SuccessPage
  },
  data() {
    return {
      trash: null,
      passwordsts: false,
      showsnackbar: false,
      timeout: 5000,
      ServerError: false,
      userId: null,
      enableChange: false,
      oldpassword: null,
      password: null,
      confPassword: null,
      passwordShow: false,
      passwordShow2: false,
      err_password: false,
      err_confPassword: false,
      appLoading: false,
      msg: null,
      msg_oldPassword: null,
      msg_password: null,
      msg_password0: null,
      rules: {
        required: value => !!value || "Required",
        min: value => (!!value && value.length >= 8) || "Min 8 characters",
        password: value => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/;
          return (
            pattern.test(value) ||
            "Must contain atleast one uppercase, one lowercase,one digit and one special characters"
          );
        }
      }
    };
  },
  computed: {
    form() {
      return {
        password: this.password,
        confPassword: this.confPassword
      };
    }
  },
  mounted() {
    this.getProfile();
  },
  watch: {
    confPassword: function() {
      if (this.password != this.confPassword) {
        this.err_confPassword = true;
        this.msg_password = "Passwords not matching";
      } else {
        this.err_confPassword = false;
        this.msg_password = null;
      }
    },
    password: function() {
      axios({
        method: "GET",
        url: "/user/check/password",
        params: {
          password: this.password,
          id: this.userId
        }
      })
        .then(response => {
          if (response.data.status == false) {
            this.err_password = true;
            this.msg_password0 = response.data.msg;
          } else {
            this.err_password = false;
            this.msg_password0 = null;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
      if (this.confPassword) {
        if (this.password != this.confPassword) {
          this.err_confPassword = true;
          this.msg_password = "Passwords not matching";
        } else {
          this.err_confPassword = false;
          this.msg_password = null;
        }
      }
    }
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.userId = response.data.data._id;
          this.appLoading = false;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    checkPassword() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "user/password",
        data: {
          password: this.oldpassword
        },
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg_oldPassword = null;
            this.enableChange = true;
          } else {
            this.msg_oldPassword = response.data.msg;
            this.enableChange = false;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    submit() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;

        this.$refs[f].validate(true);
        if (!this.$refs[f].validate(true)) this.formHasErrors = true;
      });
      if (this.err_password) this.formHasErrors = true;
      if (this.err_confPassword) this.formHasErrors = true;

      if (!this.formHasErrors) {
        this.resetPassword();
      } else {
        this.msg = "Please Validate Input";
        this.showsnackbar = true;
      }
    },
    resetPassword() {
      this.appLoading = true;
      var passworddata = {};
      passworddata["password"] = this.oldpassword;
      passworddata["newpassword"] = this.password;
      passworddata["newcpassword"] = this.confPassword;
      axios({
        method: "POST",
        url: "/user/change/password",
        data: passworddata,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.trash = response;
          if (response.data.status) {
            this.appLoading = false;
            this.passwordsts = true;
            setTimeout(() => {
              this.$router.push("/Settings");
            }, 5000);
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    }
  }
};
</script>
<style scoped>
#app_settings {
  background-image: url("../../assets/home_header.png");
  /* background-color: #26af82; */
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

#app_height {
  min-height: 80vh;
}
.curpswd.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
</style>